import DefaultValidation from "@/services/validations/DefaultValidation";
import { isNull, validatePorcentagem } from "@/functions/Util";

export default class DescontoQuantidadeValidation extends DefaultValidation{
  validate(model, refs) {
    let validated = true;

    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (isNull(model.idprodutoqtdeprecoerp)) {
        refs.idErpInput.focusedOut = true;
        validated = false;
    }
    if (isNull(model.idempresa)) {
      refs.configEmpresaInput.focusedOut = true;
      validated = false;
    }
    if (isNull(model.idtabpreco)) {
      refs.configTabPrecoInput.focusedOut = true;
      validated = false;
    }
    if (isNull(model.idproduto)) {
      refs.configProdutoInput.focusedOut = true;
      validated = false;
    }
    if (isNull(model.qtdeinicio)||!this.validateQuantidade(model.qtdeinicio)) {
      refs.qtdIni.focusedOut = true;
      validated = false;
    }
    if (isNull(model.qtdefim)||!this.validateQuantidade(model.qtdefim)||model.fim<=model.qtdeinicio) {
      refs.qtdFim.focusedOut = true;
      validated = false;
    }
    if (isNull(model.diferenca)||!validatePorcentagem(model.diferenca)) {
      refs.diferenca.focusedOut = true;
      validated = false;
    }
    if (isNull(model.descmaximo)||!validatePorcentagem(model.descmaximo)) {
      refs.descMax.focusedOut = true;
      validated = false;
    }
    
    return validated;
  }

  validateQuantidade(valor){
    return valor > 0 && valor <= 99999999.99; 
  }
}